export default {
  sidebar: {
    'switchSide': 'Oldal váltása',
    'showSidebar': 'Oldalsáv megjelenítése',
    'hideSidebar': 'Oldalsáv elrejtése'
  }
}
